import React from 'react';
import Marquee from 'react-fast-marquee';
import { artistas } from '@/constants/data';

const ArtistsMarquee = () => (
  <section className="py-10 bg-[#0A2463] overflow-hidden" data-testid="artists-marquee">
    <p className="text-center text-white/50 text-xs font-body tracking-widest uppercase mb-6">Artistas que já trabalharam conosco</p>
    <Marquee speed={40} gradient={false}>
      {[...artistas, ...artistas].map((artist, i) => (
        <span key={i} className="text-2xl md:text-3xl font-heading text-white/20 mx-8 whitespace-nowrap uppercase tracking-wider">
          {artist}
        </span>
      ))}
    </Marquee>
  </section>
);

export default ArtistsMarquee;
